module.exports = __webpack_public_path__ + "img/weddings_31_V.05071584.webp";